import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { EditEventPage } from "./-components/edit-event.page";

export const Route = createFileRoute("/_auth/org/$orgId/event/$eventId/edit/")({
  component: Page
});

function Page() {
  const { org, event } = useRouteContext({ from: "/_auth/org/$orgId/event/$eventId/edit/" });
  return <EditEventPage org={org} event={event} />;
}
